import { TextField } from '@mui/material';

const LongAnswer: React.FC = (): JSX.Element => (
  <TextField
    multiline
    variant="outlined"
    sx={{ marginTop: '20px' }}
    inputProps={{
      style: {
        height: '220px',
      },
      readOnly: true,
      'data-testid': 'longTextComponent',
    }}
  />
);

export default LongAnswer;
